import { Component, Vue } from 'vue-property-decorator'

export interface PaymentSuccessResponse {
  redirect: string;
  message: string;
  hasOffersTransactionId: string;
  hasOffersAffiliateId: string;
  isFreemium: boolean;
  isFreeTrial: boolean;
  isMobile: boolean;
  accountId: string;
  email: string;
  packageId: string;
  packagePrice: string;
  packageName: string;
}

@Component
export default class PaymentHandlerMixin extends Vue {
  triggerGTMSubscriptionEvents(data: Partial<PaymentSuccessResponse>) {
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    window.dataLayer.push('onSubscriptionAdded_Any', data)

    if (!data.isFreeTrial && !data.isFreemium) {
      window.dataLayer.push('onSubscriptionAdded_Charged', data)
    }

    if (data.isFreemium) {
      window.dataLayer.push('onSubscriptionAdded_Freemium', data)
    }

    if (data.isFreeTrial) {
      window.dataLayer.push('onSubscriptionAdded_FreeTrial', data)
    }
  }

  updateUserInfo(data) {
    let packageType = 'Paid'
    if (data.isFreeTrial) {
      packageType = 'free_trial'
    } else if (data.isFreemium) {
      packageType = 'Freemium'
    }

    this.$mixpanel.updateUserInfo({
      'Package ID': data.packageId,
      'Package name': data.packageName,
      Package: packageType
    })
  }

  async paymentSuccessHandler(res: Partial<PaymentSuccessResponse>) {
    this.triggerGTMSubscriptionEvents(res)
    this.$mixpanel.track(this.$mixpanel.events.PAYMENT_REDIRECT)
    // @ts-ignore
    if (typeof window.fbq !== 'undefined') {
      // @ts-ignore
      window.fbq('trackCustom', 'Sale-ALL', {
        value: res.packagePrice,
        currency: 'USD'
      }, { eventID: 'sale-all.' + res.accountId || this.$auth.user.id })
    } else {
      this.$sentry.captureException(Error('window.fbq is not defined, check paymentSuccessHandler'))
    }
    this.updateUserInfo(res)

    this.$accessor.account.setState({
      stateName: 'membership.isFreemium',
      data: false
    })

    await this.$accessor.account.setAccount({ resources: ['membership'] })
  }

  pushToDataLayer(event: string, data: Partial<PaymentSuccessResponse>) {
    const {
      hasOffersTransactionId,
      hasOffersAffiliateId,
      isMobile,
      accountId,
      email,
      packageId,
      packagePrice,
      packageName
    } = data

    window.dataLayer.push({
      event,
      hasOffersTransactionId: hasOffersTransactionId || '',
      hasOffersAffiliateId: hasOffersAffiliateId || '',
      isMobile: isMobile ? 'true' : 'false',
      accountId,
      email,
      packageId,
      packagePrice,
      packageName
    })
  }
}
